import { Actions } from 'flummox';
import makeFetchOptions from 'utils/makeFetchOptions';
import makeParseUrl from 'utils/makeParseUrl';

function asyncResult(asyncAction) {
  return new Promise((resolve, reject) => {
    asyncAction
      .then((r) => {
        if(r.error) {
          r = r.error;
        } else if(r.result) {
          r = r.result;
        }

        resolve(r);
      })
      .catch((e) => reject(e));
  });
}

class CodeFormActions extends Actions {

  setStatus(status) {
    return status;
  }

  changeValue(name, value) {
    return { name, value };
  }

  reset() {
    return '';
  }

  retry(data) {
    fetch(makeParseUrl('cancel'), makeFetchOptions(data));
    return '';
  }

  submit(data) {
    return asyncResult(fetch(
      makeParseUrl('checkCode'),
      makeFetchOptions(data)
    ).then(r => r.json()));
  }

  addPhone(data) {
    return asyncResult(fetch(
      makeParseUrl('addPhone'),
      makeFetchOptions(data)
    ).then(r => r.json()));
  }

  submitAbuse(data) {
    return asyncResult(fetch(
      makeParseUrl('abuse'),
      makeFetchOptions(data)
    ).then(r => r.json()));
  }

}

export default CodeFormActions;



// WEBPACK FOOTER //
// ./src/actions/CodeFormActions.js